import * as styles from './styles.css';
import { IconFunctionalInformation12, Tooltip } from '@cian/ui-kit';
import { ERowType, TAnswer } from 'shared/types/questions';

interface IQuestionProps {
  row: TAnswer;
  questionId: number;
  questionTitle: string;
  needDot: boolean;
  onOtherLinks: (link: string, title: string, id: number) => void;
}

export const Question: React.FC<IQuestionProps> = ({ row, questionId, questionTitle, needDot, onOtherLinks }) => {
  if (row.type === ERowType.Link) {
    return (
      <a
        href={row.url}
        className={styles['link']}
        rel="noreferrer"
        target="_blank"
        onClick={() => onOtherLinks(row.url, questionTitle, questionId)}
      >
        {' ' + row.text}
        {needDot ? '.' : ' '}
      </a>
    );
  }

  if (row.type === ERowType.Header) {
    return <h3>{row.text}</h3>;
  }

  if (row.type === ERowType.List) {
    return (
      <ul>
        {row.rows.map((item, listKey) => (
          <li key={listKey}>
            {item.map((text, itemKey) => {
              if (text.type === ERowType.Link) {
                return (
                  <a
                    key={itemKey}
                    href={text.url}
                    className={styles['link']}
                    rel="noreferrer"
                    target="_blank"
                    onClick={() => onOtherLinks(text.url, questionTitle, questionId)}
                  >
                    {' ' + text.text}
                    {item.length - 1 === itemKey ? '.' : ' '}
                  </a>
                );
              }

              return <span key={itemKey}>{text.text}</span>;
            })}
          </li>
        ))}
      </ul>
    );
  }

  if (row.type === ERowType.Tooltip) {
    return (
      <Tooltip title={row.title}>
        <IconFunctionalInformation12 color="icon-main-default" />
      </Tooltip>
    );
  }

  return <span>{row.text}</span>;
};
